document.addEventListener("DOMContentLoaded", () => {
    const enquiryForm = document.querySelector('.enquiry-form');
    if (!enquiryForm) return;
    const submit_btn = enquiryForm.querySelector('[submit_enquiry]');
    const errorMessage = enquiryForm.querySelector('[error-message]');
    const formSuccessMessage = enquiryForm.querySelector('[form-success-message]');
    const formErrorMessage = enquiryForm.querySelector('[form-error-message]');
    const inputs = enquiryForm.querySelectorAll('input,textarea');

    // Prevent default form submission
    if (submit_btn) {
        submit_btn.addEventListener('click', (e) => {

            let valid = true;

            inputs.forEach(input => {
                // remove bordfer on input change
                input.addEventListener('input', () => {
                    input.style.border = 'none';
                    errorMessage.style.display = 'none';
                });
                // check if required fields are empty
                if (input.hasAttribute('required') && input.value === '') {
                    input.style.border = '1px solid red';
                    input.placeholder = 'This field is required';
                    errorMessage.style.display = 'block';
                    valid = false;
                    return;
                }
            });

            if (!valid) return;

            submit_btn.classList.add('loading');
            formSuccessMessage.classList.remove('show');
            formErrorMessage.classList.remove('show');

            const formData = new FormData(enquiryForm);

            // Convert FormData to a JavaScript object
            const formObject = Object.fromEntries(formData.entries());

            console.log("Form Object",formObject);

            // get current page URL
            const pageUrl = window.location.href;

            // Get cusotmer id
            let customerId = "";

            if (window.QF.customer) {
                customerId = window.QF.customer.id;
            }
            formObject.privacy = true;

            // create a new instance of the Gadget client at the `api` global connected to the Development environment
            window.api = new Gadget();

            async function fetchData() {
                try {
                    const formSubmissionRecord = await api.formSubmission.create({
                        email: formObject.email,
                        "fieldValues": {
                            "firstName": formObject.first_name,
                            "lastName": formObject.last_name,
                            "telephone": formObject.phone,
                            "email": formObject.email,
                            "customerType": formObject.customer_type,
                            "message": formObject.message,
                            "siteAddressPostCode": formObject.site_address_postcode,
                            "acceptsDataPrivacyTerms": formObject.privacy,
                            "shopifyVariantId": formObject.variant_id
                        },
                        formType: {
                            _link: "1",
                        },
                        page: pageUrl,
                        shopifyCustomer: {
                            _link: customerId,
                        },
                    });

                    // Validate response
                    if (formSubmissionRecord) {
                        console.log("Form Submission Record", formSubmissionRecord);
                        formSuccessMessage.classList.add('show');
                        submit_btn.classList.remove('loading');
                    }

                } catch (error) {
                    // Catch and handle any errors
                    console.error("An error occurred:", error);
                    formErrorMessage.classList.add('show');
                    submit_btn.classList.remove('loading');
                }
            }

            fetchData();
        });
    }
});